import { FilterListBean, FilterListControllerApi, ItemResponseFilterListBeanObject, ListResponseFilterListBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class FilterListApi extends BaseApi {
    api: FilterListControllerApi

    constructor() {
        super()
        this.api = new FilterListControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort): Promise<ListResponseFilterListBean> {
        return this.call(() => this.api.filterLists({ query: { size, page, sort } }))
    }

    all(): Promise<ListResponseFilterListBean> {
        return this.call(() => this.api.filterLists())
    }

    allByAdvertiser(advertiserId, sort): Promise<ListResponseFilterListBean> {
        return this.call(() => this.api.filterListsByAdvertiser(advertiserId, { query: { sort } }))
    }

    create(filterList: FilterListBean): Promise<ItemResponseFilterListBeanObject> {
        return this.call(() => this.api.createFilterList(filterList))
    }

    edit(id: any, filterList: FilterListBean): Promise<ItemResponseFilterListBeanObject> {
        return this.call(() => this.api.editFilterList(filterList, id))
    }

    view(id: any): Promise<ItemResponseFilterListBeanObject> {
        return this.call(() => this.api.filterList(id))
    }

    delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteFilterList(id))
    }
}

const filterListApi = new FilterListApi()
export default filterListApi


// WEBPACK FOOTER //
// ./src/component/app/filterList/FilterListApi.ts